import React, {
  useEffect, useState, useRef, useMemo, useCallback
} from 'react';
import Styles from './simpleKeyboard.module.scss';
import cn from 'classnames';
import { connect } from 'react-redux';
import 'react-simple-keyboard/build/css/index.css';
import { keyboardInput, keyboardClose, keyboardCloseForDone, keyboardClearField } from '@reducers/keyboard';
import { bindActionCreators } from 'redux';
import { flowType } from '@utility/userInfo';
import { replaceAll, urlSearchParams, getObjectValue } from '@utility/utills';
import Keyboard from '@components/KeyboardV2';

const VirtualKeyboard = ({
  isKeyboardOpen,
  type,
  value,
  maxLength,
  isAlpha,
  name,
  isDecimal,
  countryCode,
  isDone,
  ...props
}) => {
  const storeInfo = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('auth')), {});
  const isKiosk = flowType() === 'kiosk';
  const [keyboardType, setKeyboardType] = useState('number');
  const [inputValue, setInputValue] = useState(value || '');
  const inputValueRef = useRef(inputValue);
  inputValueRef.current = inputValue;
  const keyboardInputRef = useRef(props.keyboardInput);
  keyboardInputRef.current = props.keyboardInput;
  const keyboardCloseForDoneRef = useRef(props.keyboardCloseForDone);
  keyboardCloseForDoneRef.current = props.keyboardCloseForDone;
  const [isLandScape, setIsLandScape] = useState(true)

    useEffect(() => {
      const handleResize = () => {
        setIsLandScape(window.innerWidth > window.innerHeight);
      };
      window.addEventListener('resize', handleResize);
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, [])
  const paymentType = useMemo(
    () => Number(urlSearchParams('screenType')) || 1,
    []
  );
  const isEmailKeyboard = useMemo(() => {
    const pathname = window.location.pathname;
    return (
      pathname.includes('/receipt') && keyboardType === 'textWithNumericEmail'
    );
  }, [window.location.pathname, keyboardType]);
  const caps = useCallback(() => {
    return isKiosk ? 'shift' : type;
  }, [isKiosk, type]);

  const returnMaxLength = useCallback(() => {
    if (
      Number(countryCode) === 1 &&
      name.includes('phone') &&
      typeof value != 'boolean' &&
      value?.includes('-') &&
      replaceAll(value, '-').length < 10
    ) {
      return 12;
    }
    return maxLength;
  }, [countryCode, name, value, maxLength]);

  const onClickBtn = useCallback((e) => {
    const current = inputValueRef.current;
    const keyboardVal = e === '{bksp}' ? current.slice(0, -1) : current.concat(e);
    setInputValue(keyboardVal);
    keyboardInputRef.current(keyboardVal);
  }, []);

  const ClearLogic = useMemo(() => {
    return connect(state => ({
      keyboardInputValue: state.keyboard?.keyboardInputValue,
    }))(({ keyboardInputValue, keyboardInput, keyboardClearField, isCross, paymentType, setInputValue }) => {
      useEffect(() => {
        if ((isCross && [22].includes(paymentType)) || keyboardInputValue?.length === 0) {
          setInputValue('');
          keyboardInput('');
          keyboardClearField(false);
        }
      }, [isCross, keyboardInputValue, paymentType, keyboardInput, keyboardClearField, setInputValue]);
      return null;
    });
  }, []);

  useEffect(() => {
    if (value) {
      setInputValue(value);
      props.keyboardInput(value);
    } else {
      setInputValue('');
    }
    if (isAlpha) {
      setKeyboardType('numericAlpha');
  } else {
      setKeyboardType(
        type === 'number' || name.includes('phone')
          ? 'numericDefaultWithDone'
          : caps()
      );
    }
  }, [isKeyboardOpen, countryCode, value]);

  const hasZipcode = storeInfo?.loyaltyInfo?.smsOptInFields?.includes('zipcode');
  const hasDisclaimer = storeInfo?.loyaltyInfo?.supportsOptIn;
  const hasPhone = storeInfo?.loyaltyInfo?.optInMethods?.includes('phone');

  let keyboardBottomClass = '';
  if (hasZipcode && hasPhone && hasDisclaimer) {
  keyboardBottomClass = Styles.keyboardEmailRecipt3;
} else if (hasZipcode && hasPhone){
  keyboardBottomClass = Styles.keyboardEmailRecipt2 ;
}

  const closeKeyboard = useCallback(() => {
    keyboardCloseForDoneRef.current();
  }, []);

  const setinputEmpty = useCallback(() => {
    keyboardInputRef.current('');
    setInputValue('');
  }, []);

  const memoizedBtnSize = useMemo(() => {
    return isKiosk ||
      keyboardType === 'emailText' ||
      keyboardType === 'text' ||
      keyboardType === 'textWithotNumeric'
      ? 'btn35'
      : `btn35 ${isLandScape ? Styles.btnSizeMail : 'fs-30'}`;
  }, [isKiosk, keyboardType, isLandScape]);

  const memoizedCustomClass = useMemo(
    () => `fs-30 p-2 ${Styles.keyboredBackground}`,
    []
  );

  const memoizedMaxLength = useMemo(() => returnMaxLength(), [
    returnMaxLength,
  ]);

  const memoizedKeyboard = useMemo(() => (
    <Keyboard
      setKeyboardType={setKeyboardType}
      onClickBtn={onClickBtn}
      type={isKiosk ? 'kiosk' : keyboardType}
      closeKeyboard={closeKeyboard}
      btnSize={memoizedBtnSize}
      customClass={memoizedCustomClass}
      maxLength={memoizedMaxLength}
      typed={inputValue}
      setinputEmpty={setinputEmpty}
      screenType="receiptPopUp"
      isDone={isDone}
      isLandScape={isLandScape}
    />
  ), [
    setKeyboardType,
    onClickBtn,
    isKiosk,
    keyboardType,
    closeKeyboard,
    memoizedBtnSize,
    memoizedCustomClass,
    memoizedMaxLength,
    inputValue,
    setinputEmpty,
    isDone,
    isLandScape,
  ]);

  return isKeyboardOpen ? (
    <div
      className={cn(
        [22].includes(paymentType) && isLandScape ? 'px-0' : 'px-3',
        keyboardType === 'numericWithBin'
          ? [22].includes(paymentType)
            ? Styles.keyboardTextRecipt
            : Styles.keyboard
          : [22].includes(paymentType)
          ? ` ${keyboardBottomClass}  ${
              isLandScape
                ? isEmailKeyboard
                  ? Styles.keyboardEmailReciptLandscape
                  : Styles.keyboardTextReciptLandscape
                : Styles.keyboardEmailRecipt
            }`
          : 'px-3',
        isLandScape
          ? isEmailKeyboard
            ? [22, 27].includes(paymentType)
              ? Styles.keyboardLandscap2
              : Styles.keyboardLandscape1
            : Styles.keyboardLandscape
          : Styles.keyboard1
      )}
    >
      <ClearLogic
        isCross={props.isCross}
        paymentType={paymentType}
        setInputValue={setInputValue}
        keyboardInput={props.keyboardInput}
        keyboardClearField={props.keyboardClearField}
      />
      {memoizedKeyboard}
    </div>
  ) : (
    <div className="d-none" />
  );
};

const mapStateToProps = ({ keyboard }) => ({
  isKeyboardOpen: keyboard.isKeyboardOpen,
  type: keyboard.type,
  name: keyboard.name,
  value: keyboard.value,
  maxLength: keyboard.maxLength,
  isAlpha: keyboard.isAlpha,
  countryCode: keyboard.countryCode,
  isDecimal: keyboard.isDecimal,
  isDone: keyboard.isDone,
  isCross: keyboard.isCross,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  keyboardInput,
  keyboardClose,
  keyboardCloseForDone,
  keyboardClearField
}, dispatch);

const VirtualKeyboardMemo = React.memo(VirtualKeyboard);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VirtualKeyboardMemo);
